import { SET_FIRST_CHAT, SET_RETRIEVAL_MODE, SET_CHAT_LIST, SET_LOADER_STATUS, SET_BATCH_ID, SET_CHAT_LIST_NEXT_URL, SET_CHAT_LIST_HAS_MORE, SET_SEARCH, SET_THINKING_MODE } from "./constants";

export const initialState = {
  firstChat: true,
  retrievalMode: "auto",
  chatList: [],
  loaderStatus: false,
  batchId: null,
  chatListNextUrl: null,
  chatListHasMore: true,
  search: "",
  thinkingMode: "instant",
};

const chatBotReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FIRST_CHAT:
      return {
        ...state,
        firstChat: action.firstChat,
      };
    case SET_RETRIEVAL_MODE:
      return {
        ...state,
        retrievalMode: action.retrievalMode,
      };
    case SET_CHAT_LIST:
      return {
        ...state,
        chatList: action.chatList,
      };
    case SET_LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case SET_BATCH_ID:
      return {
        ...state,
        batchId: action.batchId,
      };
    case SET_CHAT_LIST_NEXT_URL:
      return {
        ...state,
        chatListNextUrl: action.chatListNextUrl,
      };
    case SET_CHAT_LIST_HAS_MORE:
      return {
        ...state,
        chatListHasMore: action.chatListHasMore,
      };
    case SET_SEARCH:
      return {
        ...state,
        search: action.search,
      };
    case SET_THINKING_MODE:
      return {
        ...state,
        thinkingMode: action.thinkingMode,
      };
    default:
      return state;
  }
};

export default chatBotReducer;
